/**
 * English - `faqs`: the FAQs screen - the questions shoppers ask and the
 * shop's answers, drawn by the storefront's FAQ sections. They belong to the
 * store, not to a theme.
 */
const faqs: Record<string, string> = {
  title: 'FAQs',
  intro:
    "Questions customers often ask, with your answers. They appear in your storefront's FAQ sections; in the theme customizer, each FAQ section picks which questions it shows. They are kept when you switch themes.",
  add: 'Add question',
  loading: 'Loading…',
  load_error: 'This list could not be loaded. Please refresh the page.',
  empty_title: 'No questions yet',
  empty_description: 'Add the first question customers ask you - about delivery, returns, appointments or anything else.',
  read_only: 'You can view this list but not change it.',
  visible: 'Shown',
  hidden: 'Hidden',
  move_up: 'Move up',
  move_down: 'Move down',
  edit: 'Edit',
  delete: 'Delete',
  delete_title: 'Delete question',
  delete_confirm: 'Delete "{question}"? It disappears from every FAQ section on your storefront. This cannot be undone.',
  saved: 'Saved.',
  deleted: 'Deleted.',
  generic_error: 'That did not save. Please try again.',

  'form.add_title': 'Add question',
  'form.edit_title': 'Edit question',
  'form.question': 'Question',
  'form.question_placeholder': 'How long does delivery take?',
  'form.answer': 'Answer',
  'form.answer_hint': 'Line breaks are kept.',
  'form.is_active': 'Show on the storefront',
  'form.cancel': 'Cancel',
  'form.save': 'Save',
  'form.saving': 'Saving…',

  'errors.required': 'This field is required.',
  'errors.too_long': 'Keep this to {max} characters or fewer.',
};

export default faqs;
